module.exports = {"id":"189459","name":"Jaime Romero","rating":"74","photo":"./data/images/photos/0/189459.png","club":{"name":"CD Lugo","logo":"./data/images/clubs/CDLugo.png"},"positions":["MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JaimeRomero0.json
// module id = 1876
// module chunks = 0